/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('core/base-screen',['require','underscore','jquery','backbone','marionette','modernizr','json!content/json/global.json','core/engine'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var _ = require('underscore');
  var $ = require('jquery');
  var Backbone = require('backbone');
  var Marionette = require('marionette');
  var Modernizr = require('modernizr');
  var global = require('json!content/json/global.json');
  var Engine = require('core/engine');

  /*****************************************************************************************************************///}

  var BaseScreen = Marionette.LayoutView.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    el: '<div data-role="page" class="page">',
    template: _.template('<div data-role="content" class="content"></div>'),
    modelEvents: {
      'change': 'modelChanged'
    },
    options: { },
    media: null,
    channel: null,
    fxChannel: null,
    ambientChannel: null,
    page: null,
    radio: Backbone.Wreqr.radio.channel('global').vent,
    suspended: false,
    skippable: false,

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      console.warn('BaseScreen::initialize');
      ////console.log(this);
      this.suspended = false;

      this.page = options.page;
      this.template = options.template;

      this.model = this.page.get('data').clone();
      this.model.set('global', global);
      this.model.set('minigames', options.model.get('minigames'));
      this.listenTo(this.page.get('data'), 'change', this.dataChanged);

      if (this.page.get('earnedPoints') === 0)
      {
        this.page.set('maxPoints', 0.1);
        //this.page.set('earnedPoints', 0.1);
      }

      this.options = _.assign(this.options, this.model.get('options'));

      this.setLayout();
      this.setInterface();
    },

    setLayout: function()
    {
      this.$el.addClass(this.page.getLayout());
      this.$el.attr('id', this.page.get('id'));
    },

    setInterface: function()
    {
      //console.log('BaseScreen::setInterface');

      var ui = { 'help': false, 'caption': true, 'badge': false };

      // standard ui settings
      if (!this.page.get('autonomous'))
      {
        ui.home = true;
        ui.back = true;

        //if (this.page.get('complete'))
        ui.next = true;
      }

      // custom ui settings
      _.assign(ui, this.page.get('ui'));

      this.radio.trigger('ui.update', ui);
    },

    dataChanged: function(model)
    {
      ////console.log('BaseScreen::dataChanged');
      this.model.set(model.toJSON());
    },

    modelChanged: function()
    {
      ////console.log('BaseScreen::modelChanged');
      this.render();
    },

    playMedia: function(media, options, callback)
    {
      //console.log('play media', this.model, media, options);

      media = media || this.model.get('media');
      callback = callback || this.onMediaEnded;
      options = options || { };

      _.assign(options, _.omit(media, ['filename', 'caption', 'character', 'cc']));

      ////console.log(options);

      if (media)
      {
        options.caption = {
          character: media.character,
          text: media.caption
        };

        options.cc = media.cc;

        if (this.channel)
          this.channel.off($.jPlayer.event.ended);

        this.channel = Engine.module('Media').play(media.filename, options);
        this.channel.on($.jPlayer.event.ended, $.proxy(callback, this));
      }
      else
      {
        //console.log('No media found.');
      }
    },

    playSoundFX: function(filename, options)
    {
      if (!this.fxChannel)
        this.fxChannel = Engine.module('Media').openChannel();

      this.fxChannel.play(filename, options);
    },

    playAmbient: function(filename, options)
    {
      this.ambientChannel = Engine.module('Media').bgChannel;
      options.channel = this.ambientChannel;
      Engine.module('Media').play(filename, options);
    },

    playAmbientAudio: function(noTouch, loop)
    {
      noTouch = noTouch === undefined ? Modernizr.touch : noTouch;
      loop = loop === undefined ? true : loop;

      var $ambientAudio = this.model.get('ambient-audio');
      if ($ambientAudio && !noTouch)
      {
        this.playAmbient($ambientAudio, {loop: loop});
        //this._ambientSC = $ambientAudio.sound.play(0, 500);
      }
    },

    onMediaEnded: function(e)
    {
      //console.log('BaseScreen::onMediaEnded');

    },

    suspend: function()
    {
      this.suspended = true;
      if (this.channel)
        this.channel.suspend();
    },

    resume: function(force)
    {
      this.suspended = false;
      if (this.channel)
        this.channel.resume(force);
    },

    get: function(selector)
    {
      return this.$el.find(selector);
    },

    onBeforeDestroy: function()
    {
      if (this.channel)
      {
        //this.channel.player.off($.jPlayer.event.ended);
        this.channel.off($.jPlayer.event.ended);//, $.proxy(callback, this));
        this.channel.cleanup();
      }

      if (this.fxChannel)
        this.fxChannel.destroy();

      //console.warn('obd', this.ambientChannel);
      if (this.ambientChannel)
      {
        //alert('am');
        this.ambientChannel.cleanup();
      }

      this.customDestroy();

      this.model.destroy();
    },

    finish: function()
    {
      //console.log('BaseScreen::finish');
      if (!this.page.get('autonomous'))
        this.radio.trigger('screen.complete', this);

      this.page.finish();

      if (this.page.get('earnedPoints') === 0)
      {
        this.page.set('earnedPoints', 0.1);
      }

      if (this.options['autoAdvance'])
        this.radio.trigger('ui.button.pressed.next');
    },

    customDestroy: function()
    {
      // null
    }

  /*****************************************************************************************************************///}

  });

  return BaseScreen;

});

